import { staticContentService } from '~/api/local-api/localService';
import { AXIOS_TIMEOUT } from '~/core/constants';
import { ApplianceModel } from '~/core/models';

export type PartialAppliance = Pick<
  ApplianceModel,
  'productId' | 'imageUrl' | 'consumerDesc' | 'type' | 'priceWithoutDiscount'
>;

const predefinedCookingAppliancesApi = staticContentService.injectEndpoints({
  endpoints: (builder) => ({
    fetchPredefinedCookingAppliances: builder.query<PartialAppliance[], void>({
      query: () => ({
        url: './public/mock/predefined-cooking-appliances.json',
        method: 'GET',
      }),
    }),
    fetchInStoreCookingAppliances: builder.query<ApplianceModel[], string>({
      query: (url: string) => ({
        url,
        method: 'GET',
        timeout: AXIOS_TIMEOUT,
      }),
    }),
  }),
});

export const {
  useLazyFetchPredefinedCookingAppliancesQuery,
  useLazyFetchInStoreCookingAppliancesQuery,
} = predefinedCookingAppliancesApi;
